import React from 'react'
import StudentEnquiryForm from '../../features/commonfile/StudentEnquiryForm'

const ParentCounsellorStudentEnquiryPage = () => {
  return (
    <StudentEnquiryForm/>
  )
}

export default ParentCounsellorStudentEnquiryPage